import React, { Component } from 'react';
import Boutons from './Boutons';

class ChoixInitial extends Component{

    constructor (props){
        super (props);

        this.state = {
            valide: false,
            prochain: "situation",
        }
    }

    componentDidMount () {
        this.props.callback( {type: "reinit", valeur: "initial" });
    }

    action( avis ){
        const { callback } = this.props;
        let prochain = "situation";

        if (avis) prochain = "situation";
        else prochain = "resultat";

        callback( {type: "avis", valeur: avis });        
        this.setState ( {valide:true, prochain: prochain });
    }

    render () {
        const { avis, callback } = this.props;
        const { prochain, valide } = this.state;

        return (
            <div className="row avecOuSansAvis">
                <div className="col-sm-12">
                    <h2>1- Mes informations personnelles</h2>
                    <div className="input-group">
                        <label>
                            <input type="radio" name="myRadioInput" value="Oui" checked={avis === true} onChange={ () => this.action( true ) }/>
                            <span> Je souhaite bénéficier d'un tarif préférentiel calculé en fonction de mes revenus.</span>
                        </label>
                    </div>
                    <div className="input-group">
                        <label>
                            <input type="radio" name="myRadioInput" value="Non" checked={avis === false} onChange={ () => this.action ( false ) } />
                            <span> Je ne souhaite pas communiquer mon avis d'imposition : je bénéficierai donc automatiquement du tarif préférentiel correspondant à la tranche la plus élevée.</span>
                        </label>
                    </div>   
                    <Boutons suivant={prochain} valide={valide} callback={callback}/>
                </div>         
            </div>
        )
    }
}

export default ChoixInitial;